import { render, staticRenderFns } from "./SdOverlay2.vue?vue&type=template&id=2e157624&scoped=true"
import script from "./SdOverlay2.vue?vue&type=script&lang=js"
export * from "./SdOverlay2.vue?vue&type=script&lang=js"
import style0 from "./SdOverlay2.vue?vue&type=style&index=0&id=2e157624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e157624",
  null
  
)

export default component.exports